export default __webpack_public_path__ + "static/media/cp icon.7a0792bf.svg";